"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.928 4c.988.026 1.927.658 2.566 1.754a3.61 3.61 0 0 1-.322 4.143c-.416.508-.894.962-1.346 1.44-.272.288-.529.59-.822.854-.697.624-1.522.876-2.447.739a2.7 2.7 0 0 1-1.44-.69 10 10 0 0 1-.818-.858c-.33-.384-.2-.896.258-1.1a.66.66 0 0 1 .748.161l.597.627c.645.684 1.608.647 2.246.018.68-.672 1.354-1.359 1.958-2.097.562-.687.63-1.505.296-2.333-.543-1.348-2.22-1.685-3.264-.662-.206.201-.388.427-.6.623-.279.256-.694.217-.942-.07a.66.66 0 0 1 .003-.904c.35-.388.672-.805 1.124-1.09.591-.374 1.198-.556 2.205-.555"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.409 15.999c-1.654-.037-3.065-1.284-3.349-2.93a3.7 3.7 0 0 1 .398-2.465c.132-.242.304-.469.492-.67.63-.684 1.253-1.376 1.921-2.02.888-.856 1.939-1.092 3.118-.675.386.136.716.358 1.004.64.24.236.47.484.693.735a.678.678 0 0 1-.96.955c-.205-.188-.378-.409-.573-.605-.416-.418-.922-.604-1.502-.49a1.76 1.76 0 0 0-.99.578c-.54.601-1.098 1.183-1.654 1.769-.845.887-.83 2.496.151 3.298.734.6 1.927.693 2.717-.19.164-.183.343-.353.521-.523.285-.27.645-.277.94-.027.28.24.35.62.113.918-.724.915-1.59 1.613-2.817 1.7-.074.006-.149 0-.224 0z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LinkIcon20.js.map